import { type FC } from "react";
import { BottomFixedBar } from "@clientFrontend/features/scout/components/BottomFixedBar";
import { Link } from "@root/shared/components/Link";
import { Button } from "@root/shared/components/Button";
import * as styles from "./styles.css";

type Props = {
  checkedUserCount: number;
  scoutCount?: number;
  isDisabled: boolean;
  resetAllUser: () => void;
  scoutUrl?: string;
  handleClickLink: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  autoSelectAvailableRole?: boolean;
};

// おまかせ求人選択機能を使用できる上限数
const AUTO_SELECT_USER_LIMIT = 200;

export const FixedButtons: FC<Props> = ({
  checkedUserCount,
  scoutCount,
  isDisabled,
  resetAllUser,
  scoutUrl,
  handleClickLink,
  autoSelectAvailableRole = false,
}) => (
  <BottomFixedBar isShow={!!(checkedUserCount && checkedUserCount > 0)}>
    <div className={styles.fixedBarOuter}>
      {checkedUserCount > 200 && autoSelectAvailableRole && (
        <div className={styles.countInfo}>
          おまかせ求人選択の上限は{AUTO_SELECT_USER_LIMIT}件です。
        </div>
      )}
      <p className={styles.textOuter}>
        一括スカウト <span className={styles.targetCount}>{checkedUserCount}</span>通 / 残数{" "}
        {scoutCount}通
      </p>
      <div className={styles.buttonOuter}>
        <Button
          theme={isDisabled ? "disabled" : "secondary"}
          onClick={resetAllUser}
          disabled={isDisabled}
        >
          リセット
        </Button>
        <Link
          href={scoutUrl}
          theme={isDisabled ? "disabled" : "primary"}
          onClick={(event) => handleClickLink(event)}
        >
          送信
        </Link>
      </div>
    </div>
  </BottomFixedBar>
);
